import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 12\" id=\"icon-edit\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.396 1.146a.5.5 0 0 1 .708 0l1.25 1.25a.5.5 0 0 1 0 .708l-6 6A.5.5 0 0 1 4 9.25H2.75a.5.5 0 0 1-.5-.5V7.5a.5.5 0 0 1 .146-.354l6-6ZM8.207 2.75l.543.543.543-.543-.543-.543-.543.543ZM8.043 4 7.5 3.457l-4.25 4.25v.543h.543L8.043 4ZM1 10.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol